import { Type } from '@angular/core';

export class QuesItem {
  constructor(public name:string,public component: Type<any>, public data: any) {}
}

export interface IQuesComponentInterface {
    data: any;
    id: any;
    deleteQuest: any; //output for delete
}
